module.exports = __webpack_public_path__ + "media/CogDing.d5e6efc3.wav";